import { createFileRoute } from "@tanstack/react-router";

const PRIVACY_TITLE = "Privacy Policy | Glider";
const PRIVACY_DESCRIPTION =
  "How Glider collects, uses, shares, and protects personal data across the website and platform.";

export const Route = createFileRoute("/policy")({
  head: () => ({
    meta: [
      { title: PRIVACY_TITLE },
      { content: PRIVACY_DESCRIPTION, name: "description" },
      { content: PRIVACY_TITLE, property: "og:title" },
      { content: PRIVACY_DESCRIPTION, property: "og:description" },
      { content: "website", property: "og:type" },
      { content: "summary", name: "twitter:card" },
      { content: PRIVACY_TITLE, name: "twitter:title" },
      { content: PRIVACY_DESCRIPTION, name: "twitter:description" },
    ],
  }),
});
